import React from 'react';
import {
    ClosingDateResponse,
    ClosingDateResponseStatus,
} from '../../../slices/marketplace/closing-date/models/engagement-closing-date.model';
import {
    TimelineParty,
    getPartyName,
} from '../../../slices/marketplace/timeline/models/enums/timeline-party.enum';

const PARTY_DISPLAY_ORDER = [TimelineParty.Buyer, TimelineParty.Seller];

interface ClosingDateChip {
    text: string;
    badgeClass: string;
}

const getChip = (
    response: ClosingDateResponse,
    currentUserParty?: TimelineParty | null
): ClosingDateChip => {
    if (response.status === ClosingDateResponseStatus.Accepted) {
        return { text: 'Accepted', badgeClass: 'badge-success' };
    }
    if (response.status === ClosingDateResponseStatus.Declined) {
        return { text: 'Declined', badgeClass: 'badge-danger' };
    }
    return response.party === currentUserParty
        ? { text: 'Awaiting your response', badgeClass: 'badge-warning' }
        : { text: 'Pending', badgeClass: 'badge-warning' };
};

export interface ClosingDatePartyChipsProps {
    responses: ClosingDateResponse[];
    currentUserParty?: TimelineParty | null;
}

export const ClosingDatePartyChips = ({
    responses,
    currentUserParty,
}: ClosingDatePartyChipsProps) => {
    return (
        <div className="closing-date-party-chips">
            {PARTY_DISPLAY_ORDER.map((party) => {
                const response = responses.find((r) => r.party === party);
                if (!response) {
                    return null;
                }
                const chip = getChip(response, currentUserParty);
                return (
                    <span
                        key={party}
                        className="closing-date-party-chips__item">
                        <span className="closing-date-party-chips__party">
                            {getPartyName(party)}
                        </span>
                        <span
                            className={`badge badge-pill ${chip.badgeClass}`}>
                            {chip.text}
                        </span>
                    </span>
                );
            })}
        </div>
    );
};
